import React from 'react';
import { classNames } from '@/utils/class-names';

interface ErrorScreenProps {
  className?: string;
  message?: string;
}

export const ErrorScreen: React.FC<ErrorScreenProps> = ({
  className,
  message = 'Something went wrong. Please try again.',
}) => {
  return (
    <div className={classNames('flex min-h-96 flex-col items-center justify-center p-8 text-center', className || '')}>
      <div className="w-full max-w-md rounded-lg border border-red-200 bg-red-50 p-6">
        <div className="mb-4 text-4xl text-red-500">⚠️</div>
        <h2 className="mb-2 text-xl font-semibold text-red-800">Error</h2>
        <p className="text-red-600">{message}</p>
      </div>
    </div>
  );
};
